const MAX_MESSAGE_LENGTH = 200;

export function sanitizeBackendMessage(message: string): string | null {
  const cleaned = message.replace(/<[^>]*>/g, '').trim();
  if (!cleaned) return null;
  return cleaned.length > MAX_MESSAGE_LENGTH
    ? `${cleaned.slice(0, MAX_MESSAGE_LENGTH).trimEnd()}…`
    : cleaned;
}

export function extractBackendMessage(error: unknown): string | null {
  if (!error || typeof error !== 'object') return null;

  const e = error as { error?: unknown; message?: unknown; status?: number };
  const body = e.error;

  if (typeof body === 'string') {
    return sanitizeBackendMessage(body);
  }

  if (body && typeof body === 'object' && !Array.isArray(body)) {
    const backendField = (body as { error?: unknown }).error;
    if (typeof backendField === 'string') {
      return sanitizeBackendMessage(backendField);
    }
  }

  if (Array.isArray(body)) {
    const messages: string[] = [];
    for (const item of body) {
      const itemMessage =
        item && typeof item === 'object' ? (item as { message?: unknown }).message : undefined;
      if (typeof itemMessage === 'string') {
        const cleaned = sanitizeBackendMessage(itemMessage);
        if (cleaned) messages.push(cleaned);
      }
      if (messages.length >= 2) break;
    }
    if (messages.length) return messages.join('; ');
  }

  if (e.status === 0) return null;

  if (typeof e.message === 'string') {
    return sanitizeBackendMessage(e.message);
  }

  return null;
}
